import { render, staticRenderFns } from "./ChangeBookingContact.vue?vue&type=template&id=bf56c63a&scoped=true"
import script from "./ChangeBookingContact.vue?vue&type=script&lang=js"
export * from "./ChangeBookingContact.vue?vue&type=script&lang=js"
import style0 from "./ChangeBookingContact.vue?vue&type=style&index=0&id=bf56c63a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf56c63a",
  null
  
)

export default component.exports